@if (!fileInfo.isVideo && !fileInfo.isPdf && !fileInfo.isImage) {
  <ngx-doc-viewer [url]="fileInfo.url" viewer="office"
    googleCheckContentLoaded="true" googleCheckInterval="8000" googleMaxChecks="5" style="width: 100%; height:100vh;">
  </ngx-doc-viewer>
}
@if (fileInfo.isPdf && fileInfo.url) {
  <pdf-viewer [src]="fileInfo.url" [render-text]="true" [original-size]="false"
    style="width: 100%;height:100vh;">
  </pdf-viewer>
}

@if (fileInfo.isVideo) {
  <video controlsList="nodownload" [src]="fileInfo.url"
    poster="/assets/images/audio-recording.gif" class="video" style="width: 100%; height: auto" controls autoplay>
    <track
      label="English"
      kind="subtitles"
      srclang="en"
      default />
    </video>
  }
  @if (fileInfo.isImage) {
    <img [src]="fileInfo.url" style="width:100%;" alt="File_Info_Img"/>
  }
  <p style="text-align: center">{{ fileInfo.message }}</p>